import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { SubType } from '@shared/constants';
import { WinCardFourthVariantConfig } from '@shared/models';
import {
  AmountPartsPipe,
  RewardPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-variant4',
  styleUrl: './variant4.component.scss',
  templateUrl: './variant4.component.html',
  imports: [RewardPipe, VariableReplacementPipe, AmountPartsPipe],
})
export class Variant4Component extends BaseComponent {
  amount = input<number>(0);
  subType = input<SubType>(SubType.DEFAULT);
  config = input.required<WinCardFourthVariantConfig>();
}
